<template>
  <div class="loyalty-cta">
    <p>{{preamble}}</p>
    <a @click=signInToLoyalty() class="button button--secondary">{{text}}</a>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { COMMERCE_API_URL } from '@vue/common/constants/config'

function postFormWithHiddenField(url, hiddenFieldName, hiddenFieldValue) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;

  const hiddenInput = document.createElement('input');
  hiddenInput.type = 'hidden';
  hiddenInput.name = hiddenFieldName;
  hiddenInput.value = hiddenFieldValue;

  form.appendChild(hiddenInput);

  // Append the form to the body (required for submission)
  document.body.appendChild(form);
  form.submit();
}

export default {
  name: 'LoyaltyCTA',
  props: {
    preamble: {
      type: String,
      default: "Get a better rate by signing in",
    },
    text: {
      type: String,
      default: "Sign&nbsp;In",
    }
  },
  computed: {
    ...mapState({
    })
  },
  methods: {
    ...mapActions({
      createSession: 'session/create'
    }),
    async signInToLoyalty() {
      await this.createSession();
      const token = window.localStorage.getItem('sessionToken');

      postFormWithHiddenField(`${COMMERCE_API_URL}/loyalty/signin?returnUrl=/?signedIn`, "sessionToken", token);
    }
  }
}
</script>
